<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-buttons slot="start">
      <ion-button mode="md"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onCloseModal(true)"
                  color="orange"
                  fill="solid"> No, Don't Round Up </ion-button>
    </ion-buttons>
    <ion-title>Round Up For Charity</ion-title>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onCloseModal()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen>
  <div *ngIf="!isCustomAmount">
    <p>Would the guest like to round up for charity?</p>
    <p>
      Conversation prompt: "Your generous donation will impact
      <strong>{{menuItem.name}}</strong>"
    </p>
    <ion-row class="information">
      <ion-col size="12"
               class="ion-no-padding suggested-amount">
        <p class="text-overflow">Suggested Amount</p>
      </ion-col>
      <ion-col size="12"
               class="ion-no-padding round-up-amount">
        <img src="assets/icon/icon-charity.png"
             class="icon" />
        <p class="text-overflow">{{ suggestedAmount | currency }}</p>
      </ion-col>
      <ion-col size="12"
               class="ion-no-padding">
        <p class="text-overflow">Updated Order Total: <strong>{{ totalAmount | currency }}</strong></p>
      </ion-col>
    </ion-row>
  </div>
  <div *ngIf="isCustomAmount">
    <p>Enter a custom amount instead of rounding up to the nearest dollar.</p>
    <pos-numeric-keyboard (onValueChange)="onNumericKeyboardInput($event)"
                          [value]="amount"
                          [buttons]="[]"></pos-numeric-keyboard>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar *ngIf="!isCustomAmount"
               mode="md"
               color="light">
    <ion-buttons slot="start">
      <ion-button mode="md"
                  color="dark"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="customAmount()"> Enter a custom amount </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  color="dark"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="addCharityProduct()"> Yes, Round Up </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar *ngIf="isCustomAmount"
               mode="md"
               color="light">
    <ion-buttons slot="end">
      <ion-button mode="md"
                  color="dark"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="saveAmount()"> Save Amount</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
